<template>
    <load v-if="loading" message="Carregando Ofício" />
    <div v-else class="row">
        <div class="col-md-12">
      <botao-remanejar class="mb-3" servico="oficios" :registro="oficio" @remanejado="$router.go(-1)" />
            <!--Tabela-->
            <div class="row">
                <div class="col-12">
                    <HeaderOficio :oficio="oficio" />
                </div>
            </div>
            <div class="row" v-if="historicoStatus == false">
                <div
                    class="col-sm-12 col-md-3"
                    v-for="aba in abas"
                    :key="aba.id"
                >
                    <a
                        class="btn btn-sm btn-block d-flex align-items-center"
                        role="tab"
                        @click="
                            aba.page == 'reload'
                                ? getOficio()
                                : (page = aba.page)
                        "
                        :class="
                            page == aba.page ? 'btn-primary' : 'btn-default'
                        "
                        :title="aba.title"
                        ><i :class="aba.icon"></i> {{ aba.title }}
                    </a>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div
                        v-if="historicoStatus == false"
                        class="card mb-0 shadow"
                    >
                        <div class="card-body">
                            <div class="tab-content">
                                <div
                                    class="animate__animated animate__fadeIn"
                                    v-show="page == 'detalhe'"
                                >
                                    <form @submit.prevent="submit">
                                        <div class="row">
                                            <form-input
                                                v-model="oficio.local"
                                                grid="4"
                                                label="Local"
                                                :required="true"
                                            />

                                            <form-calendar
                                                v-model="oficio.data_local"
                                                grid="4"
                                                label="Data"
                                                :required="true"
                                            />
                                            <form-calendar
                                                v-model="
                                                    oficio.data_prazo_resposta
                                                "
                                                :required="true"
                                                grid="4"
                                                label="Prazo para a resposta"
                                            />
                                            <form-input
                                                v-model="
                                                    oficio.nome_completo_detinatario
                                                "
                                                grid="6"
                                                label="Nome completo do destinatário"
                                                :required="true"
                                            />
                                            <form-input
                                                v-model="
                                                    oficio.orgao_destinatario
                                                "
                                                grid="6"
                                                label="Nome do órgão destinatário"
                                            />

                                            <form-toggle
                                                grid="12"
                                                mt="0"
                                                v-model="campoExtra"
                                                label="Possui mais informações do destinatário?"
                                            />
                                        </div>
                                        <div class="row" v-if="campoExtra">
                                            <form-input
                                                v-model="
                                                    oficio.email_destinatario
                                                "
                                                grid="6"
                                                label="E-mail do destinatário"
                                                :required="true"
                                            />
                                            <form-input
                                                v-model="
                                                    oficio.email_resposta
                                                "
                                                grid="6"
                                                label="E-mail de resposta"
                                            />
                                            <form-input
                                                v-model="
                                                    oficio.telefone_destinatario
                                                "
                                                grid="6"
                                                label="Telefone do destinatário"
                                            />
                                            <form-input
                                                v-model="
                                                    oficio.cargo_destinatario
                                                "
                                                grid="6"
                                                label="Cargo do destinatário"
                                            />
                                            <form-toggle
                                                grid="12"
                                                mt="0"
                                                v-model="campo_extra_endereco"
                                                label="Possui informações de endereço do destinatário?"
                                            />
                                        </div>
                                        <form-endereco
                                            :item="oficio.endereco"
                                            v-if="campo_extra_endereco"
                                        />
                                        <div class="row">
                                            <form-input
                                                v-model="oficio.assunto"
                                                label="Assunto"
                                                :required="true"
                                            />
                                            <form-textarea-editor
                                                v-model="oficio.conteudo"
                                                label="Conteúdo"
                                                :required="true"
                                            />
                                            <form-select
                                                @change="verificarStatus"
                                                grid="4"
                                                v-model="oficio.status"
                                                label="Status"
                                                :itens="status"
                                                :ajuda="ajuda_status"
                                            />
                                        </div>

                                        <div
                                            class="row pt-2 px-0 d-flex justify-content-end align-items-center"
                                        >
                                            <form-toggle
                                                grid="4"
                                                class="d-flex justify-content-end"
                                                mt="0"
                                                v-model="oficio.privado"
                                                label="Sigilo?"
                                            />
                                            <div
                                            class="col-auto px-2 text-right"
                                            >
                                                <a
                                                    v-if="is_morph"
                                                    class="btn btn-default mb-0"
                                                    @click="$emit('voltar')"
                                                >
                                                    <i
                                                        class="mdi mdi-arrow-left"
                                                    />
                                                </a>
                                                <router-link
                                                    v-else
                                                    to="/dashboard/oficios"
                                                    class="btn btn-default mb-0"
                                                >
                                                    <i
                                                        class="mdi mdi-arrow-left"
                                                    />
                                                </router-link>
                                                <b-button
                                                    v-if="oficio"
                                                    :title="
                                                        $t(
                                                            'Visualizar e Imprimir'
                                                        )
                                                    "
                                                    :to="`/dashboard/oficios/show/${oficio.id}`"
                                                    class="py-1 mb-0"
                                                    size="sm"
                                                    type="button"
                                                    v-b-tooltip.hover
                                                    variant="primary"
                                                >
                                                    <i
                                                        class="mdi mdi-printer mdi-18px"
                                                    />
                                                </b-button>
                                                <button
                                                    class="btn btn-success btn-submit mb-0"
                                                    data-style="zoom-in"
                                                    type="submit"
                                                >
                                                    <i
                                                        class="mdi mdi-content-save"
                                                    />
                                                    {{ $t("Salvar") }}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div
                                    class="animate__animated animate__fadeIn"
                                    v-show="page == 'anexo'"
                                >
                                    <div class="row">
                                        <form-file
                                            grid="12"
                                            @submit="submitFile"
                                            multiple
                                            btn-text="Iniciar"
                                            label="Enviar Anexos"
                                            :progress="progressCompleted"
                                        />
                                    </div>

                                    <anexos
                                        :anexos="oficio.anexos"
                                        title="Lista de anexos associados ao ofício"
                                    />
                                </div>
                                <div
                                    class="animate__animated animate__fadeIn"
                                    v-if="page == 'history'"
                                >
                                    <div class="row">
                                        <!-- <div class="col-12">
                    <h4 class="font-weight-bold">Gestão do Ofício</h4>
                  </div> -->
                                        <HistoricoStatus
                                            @voltar="page = 'detalhe'"
                                            :id="oficio.id"
                                            :familia="oficio.familia_id"
                                            :status="status_oficio"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card mb-0 shadow card-body" v-else>
                        <div class="tab-content"></div>
                    </div>
                </div>
            </div>
        </div>
        <status-historico
            :model="model"
            modulo="Oficio"
            titulo_modulo="OFÍCIO"
            :id="oficio.id"
            :status-anterior="statusAnterior"
            :status-atual="statusAtual"
            :status="status_oficio"
            @submit="submit"
        />
    </div>
</template>
<script>
import HistoricoStatus from "./includes/HistoricoStatus";
import HeaderOficio from "./includes/HeaderOficio";
export default {
    props: ["morph", "morphOficioId"],
    components: { HistoricoStatus, HeaderOficio },
    name: "Edit",
    data() {
        return {
            is_morph: false,
            statusAtual: "",
            statusAnterior: "",
            historicoStatus: false,
            oficio: {},
            tecnicos: {},
            loading: true,
            files: {},
            status: {},
            status_oficio: {},
            progressCompleted: 0,
            model: "Oficio",
            familia: {},
            campoExtra: false,
            campo_extra_endereco: false,
            page: "detalhe",
            abas: [
                {
                    id: 1,
                    title: "DETALHES",
                    page: "detalhe",
                    icon: "mdi mdi-format-list-text mdi-18px mr-2",
                },
                {
                    id: 2,
                    title: "ANEXOS",
                    page: "anexo",
                    icon: "mdi mdi-paperclip mdi-18px mr-2",
                },
                {
                    id: 3,
                    title: "HISTÓRICO DE STATUS",
                    page: "history",
                    icon: "mdi mdi-history mdi-18px mr-2",
                },
                {
                    id: 4,
                    title: "RECARREGAR PÁGINA",
                    page: "reload",
                    icon: "mdi mdi-sync mdi-18px mr-2",
                },
            ],
            ajuda_status:`<b>ABERTO:</b> O status aberto é indicado sempre que o usuário da plataforma registra um Ofício, no caso esse status aponta que foi iniciado um registro, e está apto para gerenciamento e indicação de outros status;<br><br>
            <b>ENVIADO:</b> O status Enviado é indicado sempre que o usuário da plataforma gerencia o registro de um Ofício que foi enviado a outro setor/órgão;<br><br>
            <b>RECEBIDO :</b> O O status Recebido é indicado quando o usuário da plataforma utiliza a funcionalidade para registrar ofícios recebidos, como meio de gerar notificações de prazo e histórico de recebimento;<br><br>
            <b>RESPONDIDO:</b> O status Respondido é indicado para ser gerenciado de duas formas, no caso como meio de registrar que o Ofício Enviado foi respondido pelo Destinatário; ou como meio de registrar que o Ofício Recebido foi devidamente respondido;<br><br>
            <b>FINALIZADO:</b> O status Finalizado é indicado para ser gerenciado quando o registro do Ofício foi concluído, ou quando está pendente por algum motivo.<br><br>
            <b>INATIVO:</b>O status inativo é atribuído a um registro quando não há mais necessidade de mantê-lo por várias razões. Normalmente, isso acontece devido à duplicação de informações ou à ausência de dados relevantes. Quando um registro é marcado como inativo, isso indica que ele não está mais em uso ativo e não será mais atualizado ou mantido.`
        };
    },
    mounted() {
        this.morph ? (this.is_morph = true) : (this.is_morph = false);
        // if (typeof this.$route.query.item === "object") {
        //   this.oficio = this.$route.query.item;
        //   this.loading = false;
        // } else {
        //   this.getStatus();
        //   this.getOficio();
        //   this.getStatusFinais();
        // }

        this.getStatus();
        this.getTecnicos();
        this.getOficio();
        this.getStatusFinais();
    },
    methods: {
        getTecnicos() {
            axios.get(`api/dashboard/tecnicos/get`).then((response) => {
                this.tecnicos = response.data;
            });
        },
        getStatus() {
            axios.get(`api/dashboard/status/oficios`).then((response) => {
                this.status = response.data;
            });
        },
        verificarStatus(status) {
            this.statusAtual = status;

            const result = this.status_oficio.filter(
                (item) => item.id == status
            );
            if (result[0].final == 1) {
                //compara os status finais com o status que foi alterado, caso seja igual será aberta a janela para salva o historico
                this.$bvModal.show("status-historico-" + this.model);
            }
        },
        getStatusFinais() {
            axios
                .post(`api/dashboard/get/status/finais`, {
                    model: this.model,
                    module: "Oficio",
                })
                .then((response) => {
                    this.status_oficio = response.data;
                });
        },
        getOficio(load = true) {
            this.loading = load;
            var id = this.is_morph ? this.morphOficioId : this.$route.params.id;
            axios
                .get(`api/dashboard/oficios/${id}`)
                .then((response) => {
                    this.oficio = response.data.data;
                    this.statusAnterior = this.oficio.status;
                    this.oficio.endereco
                        ? (this.campoExtra = true)
                        : (this.campoExtra = false);
                    this.oficio.endereco.cep
                        ? (this.campo_extra_endereco = true)
                        : (this.campo_extra_endereco = false);
                })
                .finally(() => {
                    this.loading = false;
                })
                .catch((error) => {
                    swal.fire({
                        title: "Ops!",
                        html:
                            "O item não foi carregado corretamente<br>" + error,
                        icon: "error",
                    });
                    this.$router.push("/dashboard/oficios/");
                });
        },
        submitFile(files) {
            this.files = files;

            let formData = new FormData();

            if (this.files.length > 0 && this.files.length != undefined) {
                for (const i of Object.keys(this.files)) {
                    formData.append("files[]", this.files[i]);
                }
            } else {
                formData.append("files", this.files);
            }

            formData.append("id", this.oficio["id"]);

            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();

            axios
                .post(`api/dashboard/oficio/upload`, formData, {
                    header: { "Content-Type": "multipart/form-data" },
                    onUploadProgress: (event) => {
                        let progress = Math.round(
                            (event.loaded * 100) / event.total
                        );
                        this.progressCompleted = progress;
                    },
                })
                .then((response) => {
                    this.getOficio(false);
                    ladda.stop();
                    this.$snack.success({
                        button: false,
                        text: response.data.data.message,
                    });
                })
                .finally(() => {
                    this.progressCompleted = 0;
                    this.files = [];
                    formData.delete("files");
                });
        },
        submit() {
            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();

            axios
                .post(`api/dashboard/update/oficios`, {
                    oficio: this.oficio,
                    status_finais: this.status_oficio,
                })
                .then((response) => {
                    this.getOficio();
                    ladda.stop();
                    this.$snack.success({
                        button: false,
                        text: response.data.data.message,
                    });
                })
                .finally(() => {
                    this.progressCompleted = 0;
                });
        },
    },
};
</script>
<style lang="css">
.nav-link {
    cursor: pointer;
}
</style>
